<template>
  <v-dialog
    v-model="confirmation"
    max-width="290">
    <v-card>
      <v-card-title class="headline">Bu işlemi yapmak istediğinize emin misiniz?</v-card-title>

      <v-card-text>
        Eğer Tamam derseniz bu işlemin geri dönüşü olmayacaktır.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="confirmation = !confirmation" >
          İptal Et
        </v-btn>

        <v-btn
          color="blue darken-1"
          text
          @click="action()"
          @click.stop="confirmation = !confirmation">
          Tamam
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'Confirmation',
  computed: {
    ...mapFields([
      'dialog.confirmation',
      'dialog.action',
    ]),
  },
};
</script>
